module.exports = __webpack_public_path__ + "static/media/IN_Payslip_4.ab9cd590.png";